// extracted by mini-css-extract-plugin
export default {"home":"Home_home__SCgQC","home__title":"Home_home__title__1lh0e","home__progress-bar":"Home_home__progress-bar__z6+g-"};